/**
 * Placeholder for the 3 BuiltinWidget kinds not adapted for the M2 grid
 * (UTILIZATION_HEATMAP/BOTTLENECKS/WORKLOAD_STRIP — their source
 * components remain page-local to WorkloadCapacityPage, which stays a
 * separate page in M2 per the design brief's own non-goals). Renders
 * gracefully so a widget row referencing one of these (never produced by
 * the M2 add-widget palette, which only offers the other 9) degrades
 * instead of crashing.
 */
import { WidgetBoundary } from '../WidgetBoundary';
import { sectionCardStyle } from '../chartTokens';
import type { BuiltinHostProps } from './hostProps';

export function UnavailableBuiltinHost({ title, minHeight }: BuiltinHostProps) {
  return (
    <WidgetBoundary label={title} minHeight={minHeight}>
      <div style={sectionCardStyle({ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' })}>
        <span
          style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 13,
            color: 'var(--text-low)',
            textAlign: 'center',
            padding: '0 16px',
          }}
        >
          {title} isn&apos;t available on the dashboard canvas yet — see Workload &amp; Capacity.
        </span>
      </div>
    </WidgetBoundary>
  );
}
